var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cleave',_vm._g(_vm._b({staticClass:"imd-sm-input",class:{
    'right' : 'right' in _vm.$attrs
  }},'cleave',Object.assign({}, _vm.$attrs,
    {options: _vm.options,
    raw: 'masked-value' in _vm.$attrs == false}),false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }